import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import Button from "../../../components/shared/buttons/button";
import useTranslator from "../../../hooks/useTranslator";
import { useUpdateEnvVariableMutation } from "./systemVariablesApi";

const EnvVariableModal = ({ show, setShow, record }) => {
  const { _t } = useTranslator();

  const [formData, setFormData] = useState({
    title: "",
    value: "",
    notes: "",
  });

  const [updateEnvVariable, { isLoading: isUpdating }] = useUpdateEnvVariableMutation();

  useEffect(() => {
    if (show && record) {
      setFormData({
        title: record.title ?? "",
        value: record.value ?? "",
        notes: record.notes ?? "",
      });
    }
  }, [show, record]);

  const handleClose = () => setShow(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isUpdating) return;
    try {
      await updateEnvVariable({
        id: record.id,
        requestBody: {
          title: formData.title,
          value: formData.value,
          notes: formData.notes,
        },
      }).unwrap();
      handleClose();
    } catch (err) {
      console.error("Error updating env variable:", err);
    }
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("edit_env_variable", "Edit Env Variable")}
    >
      <Row>
        {/* Key — read only */}
        <Col lg={12}>
          <InputWithLabel
            label={_t("key", "Key")}
            type="text"
            name="key"
            value={record?.key || ""}
            disabled={true}
          />
        </Col>

        {/* Title */}
        <Col lg={12}>
          <InputWithLabel
            label={_t("title", "Title")}
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder={_t("enter_title", "Enter title...")}
          />
        </Col>

        {/* Value */}
        <Col lg={12}>
          <InputWithLabel
            label={_t("value", "Value")}
            type="text"
            name="value"
            value={formData.value}
            onChange={handleChange}
            placeholder={_t("enter_value", "Enter value...")}
          />
        </Col>

        {/* Notes */}
        {/* <Col lg={12}>
          <InputWithLabel
            label={_t("additional_notes", "Additional Notes (optional)")}
            type="text"
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            placeholder={_t("enter_notes", "Enter notes...")}
          />
        </Col> */}
      </Row>

      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            disabled={isUpdating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default EnvVariableModal;
